var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobboardcomment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07031 7.19765C1.07031 3.81145 3.81782 1.06641 7.20401 1.06641V1.06641C10.5929 1.06641 13.3426 3.81366 13.3426 7.20257V11.0993C13.3426 11.4605 13.3426 11.641 13.3174 11.7919C13.1877 12.5668 12.5805 13.1739 11.8057 13.3036C11.6548 13.3289 11.4742 13.3289 11.1131 13.3289H7.20155C3.81536 13.3289 1.07031 10.5838 1.07031 7.19765V7.19765Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.38064
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90234 6.42969L9.50447 6.42969",
    stroke: "#6D7D8B",
    strokeWidth: 1.38064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 9.49609H9.50419",
    stroke: "#6D7D8B",
    strokeWidth: 1.38064,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobboardcomment);
export default __webpack_public_path__ + "static/media/jobboardcomment.880ffd7a.svg";
export { ForwardRef as ReactComponent };